
{
  "familyId": "SPR-WEET-BOUW",
  "questions": [
    {
      "id": "SPR-WEET-BOUW-001",
      "familyId": "SPR-WEET-BOUW",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_woordbouwer",
      "questionType": "word_builder",
      "question": "Bouw het hele woord. Let goed op: ei of ij?",
      "context": "Je hoort het woord, maar moet zelf de juiste letters kiezen. Ei en ij klinken hetzelfde — je moet het uit je hoofd weten.",
      "data": {
        "wordBuilder": {
          "variant": "ei-ij",
          "items": [
            { "clue": "Niet gevangen, maar ___ (je mag gaan).", "word": "vrij" },
            { "clue": "Het meisje stapt in de ___ naar school.", "word": "trein" }
          ]
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "EI of IJ?",
            "content": "Ij-woorden: vrij, tijd, rijden, schrijven, blij, wijs. Ei-woorden: trein, klein, meisje, reis, leiden. De klank is hetzelfde — leer ze uit je hoofd.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "weet_bouw_ei_ij",
      "variantIndex": 1,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "'Vrij' schrijf je met ij. 'Trein' schrijf je met ei. Omdat ei en ij hetzelfde klinken, moet je deze weetwoorden uit je hoofd kennen — daarom bouw je het hele woord zelf.",
        "solutionSteps": [
          "vrij → ij-woord",
          "trein → ei-woord"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.ei-ij-confusion", "label": "ei en ij verwisseld bij het bouwen" }
        ]
      }
    },
    {
      "id": "SPR-WEET-BOUW-002",
      "familyId": "SPR-WEET-BOUW",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_woordbouwer",
      "questionType": "word_builder",
      "question": "Bouw het hele woord. Eindigt het op een d of een t?",
      "context": "Verleng het woord in je hoofd: 'honden' → dus hond met een d.",
      "data": {
        "wordBuilder": {
          "variant": "d-t",
          "items": [
            { "clue": "Een dier dat blaft en kwispelt.", "word": "hond" },
            { "clue": "Daar loop je op — je linker- en rechter___.", "word": "voet" }
          ]
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "d of t aan het eind?",
            "content": "Verleng het woord: honden → hond (d). voeten → voet (t). De letter die je in het langere woord hoort, schrijf je ook in het korte woord.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "weet_bouw_d_t",
      "variantIndex": 2,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "'Hond' eindigt op een d (honden). 'Voet' eindigt op een t (voeten). Verleng het woord om de juiste eindletter te horen.",
        "solutionSteps": [
          "honden → hond (d)",
          "voeten → voet (t)"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.eind-d-t-verwarring", "label": "eind-d en eind-t verwisseld" }
        ]
      }
    },
    {
      "id": "SPR-WEET-BOUW-003",
      "familyId": "SPR-WEET-BOUW",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "B7",
      "group": 7,
      "skill": "weetwoorden",
      "subSkill": "weet_woordbouwer",
      "questionType": "word_builder",
      "question": "Bouw het hele woord. Let op de -dt!",
      "context": "Eindigt de stam al op een d? Bij hij/zij komt er nog een t bij: vind + t = vindt.",
      "data": {
        "wordBuilder": {
          "variant": "dt",
          "items": [
            { "clue": "Hij ___ zijn sleutels terug (van vinden).", "word": "vindt" },
            { "clue": "Zij ___ op haar fiets naar huis (van rijden).", "word": "rijdt" }
          ]
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De -dt-regel",
            "content": "Eindigt de stam op een d? Bij hij/zij/het voeg je tóch een -t toe: vind + t = vindt, rij + dt = rijdt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "weet_bouw_dt",
      "variantIndex": 3,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "'Vinden' heeft stam 'vind'; bij 'hij' komt er een -t bij: vindt. 'Rijden' heeft stam 'rij'; bij 'zij' wordt het rij + dt = rijdt.",
        "solutionSteps": [
          "vind + t → vindt",
          "rij + dt → rijdt"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.dt-overgeneralize", "label": "-dt onjuist gebouwd" }
        ]
      }
    }
  ]
}
